export default {
    common: {
        title: 'Edit Image',
        cancel: 'Cancel',
        save: 'Save',
        crop: 'Crop',
        adjustments: 'Adjustments',
        filters: 'Filters',
        frames: 'Frames',
        overlays: 'Overlays',
        text: 'Text',
        stickers: 'Stickers',
        brush: 'Brush',
        ai: 'Create image using AI',
        reset: 'Reset',
        comingSoon: 'Coming Soon...',
        apply: 'Apply',
        undo: 'Undo',
        redo: 'Redo',
        flipHorizontal: 'Flip Horizontal',
        flipVertical: 'Flip Vertical',
        rotateClockwise: 'Rotate Clockwise',
        rotateAntiClockwise: 'Rotate Anti-Clockwise',
        warning: 'Warning',
        discard: 'Discard',
        continue: 'Continue editing',
        discardHeading: 'Discard your changes?',
        discardSubHeading: "If you close the image editor, your changes won't be saved.",
        subtitle: 'The supported image formats are PNG and JPEG.',
    },
};
